import { Component, OnInit , ViewChild} from '@angular/core';
import { Router } from '@angular/router';
import { DashboardService } from '../service/dashboard.service';
import { MatTableDataSource, MatPaginator, MatDatepickerInputEvent, MAT_DATE_FORMATS, DateAdapter } from '@angular/material';
import { FormControl } from '@angular/forms';

import { MatDateFormats, MAT_NATIVE_DATE_FORMATS } from '@angular/material';
import Swal from 'sweetalert2';


export const GRI_DATE_FORMATS: MatDateFormats = {
  ...MAT_NATIVE_DATE_FORMATS,
  display: {
    ...MAT_NATIVE_DATE_FORMATS.display,
    dateInput: {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
    } as Intl.DateTimeFormatOptions,
  }
};
@Component({
  selector: 'app-agtransactions',
  templateUrl: './agtransactions.component.html',
  styleUrls: ['./agtransactions.component.scss'],
  providers: [
    { provide: MAT_DATE_FORMATS, useValue: GRI_DATE_FORMATS },
  ]
})
export class AgtransactionsComponent implements OnInit {


  manualPushReq={
    invoice_no : '',
    policy_sequence :'',
    transaction_token :'',
    managerEmail : '',
    role:'admin'


  }

  userdata;
  transactions:any = [];
  searchdata;

  minDate: Date;
  maxDate: Date;

  startDate :any
  endDate  : any

  events: string[] = [];

  @ViewChild(MatPaginator) paginator: MatPaginator;

  length: number;
  pageSize: number= 10;
  pageSizeOptions = [ 10, 20,50,100];

  dataSource = new MatTableDataSource();
  displayedColumns = ['no' ,'policy_sequence', 'id', 'intermediary_name', 'phone', 'firstName',  'invoice' ,'transactionType','amount','status','date_createdd','transaction_url', 'edit']


  constructor(private router:Router, private service:DashboardService, private readonly adapter: DateAdapter<Date>) {
    const currentYear = new Date().getFullYear();
    this.minDate = new Date(currentYear - 2, 0, 1);
    // this.maxDate = new Date(currentYear + 1, 11, 31);
    this.maxDate = new Date(currentYear + 1, 0, 0);
  }

  date = new FormControl(new Date(new Date().setDate(new Date().getDate() - 30)));

  serializedDate = new FormControl((new Date()).toISOString().substring(0,10))


  ngOnInit() {


    this.userdata=JSON.parse(localStorage.getItem('userdata'))

    var today = new Date(); //get todays date
    this.endDate= today.toISOString().substring(0,10) //convert todays date to format eg.2019-08.02 and set it to end date

    today.setDate(today.getDate() - 30) // subtract 7 days from todays date
    this.startDate = today.toISOString().substring(0,10)

  //  by default pass last month
    Swal.showLoading();;
    this.service.getTransaction({email:this.userdata.email, role :this.userdata.role ,minDate: this.startDate, maxDate : this.endDate})
    .toPromise()
    .then(data=>{
      this.transactions = data;


      this.searchdata = this.transactions;
      this.dataSource.data = this.transactions;
      this.dataSource.paginator = this.paginator;
      Swal.close();

     })
     .finally(()=>{
        //format values
          this.transactions.forEach(function(a) {
            if (a.transaction_type == "MOBILEMONEYGH_TRANSACTION"){
              a.transaction_type = "Mobile Money"
            }
            if (a.transaction_type == "cash"){
              a.transaction_type = "Cash"
            }
            if (a.transaction_type == "cheque"){
              a.transaction_type = "cheque"
            }

        });

        Swal.close();
     })

  }

  find(){
   Swal.showLoading();;
    this.service.getTransaction({email:this.userdata.email, role :this.userdata.role ,minDate: this.startDate, maxDate : this.endDate}).subscribe(data=>{

      if(data){
        this.transactions = data;

        //format values
        this.transactions.forEach(function(a) {
  
          if (a.transaction_type == "MOBILEMONEYGH_TRANSACTION"){
            a.transaction_type = "Mobile Money"
          }
          if (a.transaction_type == "cash"){
            a.transaction_type = "Cash"
          }
          if (a.transaction_type == "cheque"){
            a.transaction_type = "cheque"
          }
  
      });
        this.searchdata = this.transactions;
        this.dataSource.data = this.transactions;
        this.dataSource.paginator = this.paginator;

        Swal.close();

      }else{
        Swal.close();
        (Swal as any).fire({
              title:'',
              text:'No transactions found',
              icon:"warning"
            })
      }

     
  });


  }


//View transaction status link
// onViewTransaction(url){
//   if(url)
//   window.open(url, "_blank")
//   else
//   (Swal as any).fire({
//     title:'Resource Not Found',
//     text:'Receipt not available for Cash transactions',
//     icon:"error"
//   })
// }



onManualPush(manualPush){
//do confirmation 
(Swal as any).fire({
  text:"Policy will be manually pushed for policy documents.\nDo you wish to proceed?",
  icon:"question",
  showCancelButton: true,
  showConfirmButton :true,

  // allowOutsideClick: false,
  // allowEscapeKey: false,
  allowEnterKey: false,
 
  confirmButtonText: `Yes,Proceed`,
  reverseButtons:true,

})
.then((dialogResponse)=>{
  if(dialogResponse.hasOwnProperty('value') && dialogResponse.value==true) {
  

  (Swal as any).fire({
    //title: "Loading...",
    html: "Please wait a moment",
    onBeforeOpen: () => {
      Swal.showLoading ()
    }
  })


    this.manualPushReq.transaction_token = manualPush.transaction_token ;
    this.manualPushReq.invoice_no = manualPush.invoice_no ;
    this.manualPushReq.policy_sequence = manualPush.policy_sequence;
    this.manualPushReq.managerEmail = this.userdata.email;
  
    this.manualQueryPush();

  }
})


 
}



manualQueryPush(){
  Swal.showLoading();
  this.service.manualPush(this.manualPushReq)
    .toPromise()
    .then((res: any) => {
      Swal.close()
      console.log("manualPush>>>>>>>>>" + JSON.stringify(res))

      if (res.responseCode == "000") {
       const sticker_link = res.stickerUrl;
       const cert_link = res.certificateUrl;
 
       (Swal as any).fire({
         title: 'Payment successful',
         html: res.hasOwnProperty('stickerUrl')? `SMS and Email sent with Policy details to print<br><br>Kindly print <a target='_blank' href='${sticker_link}'>Sticker</a> and <a target='_blank' href='${cert_link}'>Certificate</a>`:`Payment completed successfully;your certificate has been mailed to you!<br><br/>Kindly click the <a target='_blank' href='${res.certificateUrl}'>Preview</a> link to view certificate`,
         icon: 'success',
         confirmButtonText:'Done',
         showConfirmButton: true,
         allowOutsideClick: false,
         allowEscapeKey: false
       });

      } else if (res.responseCode == "E01") {

        if(res.responseMessage == "PAYMENT_FAILED"){
          this.NICRepush()
        }else{

        (Swal as any).fire({
          title: 'Failed',
          text: res.responseMessage,
          icon: 'error',
        });

        }


      }
      else {
        (Swal as any).fire({
          title: 'Failed',
          text: res.responseMessage,
          icon: 'error',
        });
      }


    }).catch(err => {
     console.log("manualPush>>>>>>>>>" + JSON.stringify(err))
     if(err.error.responseCode=="500"){
       this.NICRepush()
     }else{
       (Swal as any).fire({
         title: 'API Error',
         text: err.message,
         icon: 'error',
       });
     }
    

    })

}


NICRepush(){
  let requestPayload = {
    "policySequence": this.manualPushReq.policy_sequence
  }
  Swal.showLoading();
  this.service.NICRepush(requestPayload)
    .toPromise()
    .then((res: any) => {
      Swal.close()
      console.log("NICRepush>>>>>>>>>" + JSON.stringify(res))

      if (res.responseCode == "000") {

       this.manualQueryPush()

      } else if (res.responseCode == "E01") {

        (Swal as any).fire({
          title: 'Failed',
          text: res.responseMessage,
          icon: 'error',
        });

      }
      else {
        (Swal as any).fire({
          title: 'Failed',
          text: res.responseMessage,
          icon: 'error',
        });
      }


    }).catch((err: any) => {
     console.log("NICRepush>>>>>>>>>" + JSON.stringify(err));
      (Swal as any).fire({
        title: 'API Error',
        text: err.message,
        icon: 'error',
      });

    })

}

  




updateDate1(dateObject) {
  // convert object to string then trim it to yyyy-mm-dd
  const stringified = JSON.stringify(dateObject.value);
  this.startDate = stringified.substring(1, 11);
  // this.applicant.contact[0].dob = dob;

  console.log(this.startDate )
}


updateDate2(dateObject) {
  // convert object to string then trim it to yyyy-mm-dd
  const stringified = JSON.stringify(dateObject.value);
  this.endDate = stringified.substring(1, 11);
  // this.applicant.contact[0].dob = dob;

  console.log("end date " + this.endDate )
}



  search (query: string){
    this.searchdata = (query) ?this.transactions.filter( data => data.transaction_id.toLowerCase().includes(query.toLowerCase()) || data.invoice_no.toLowerCase().includes(query.toLowerCase()) || data.client_id.toLowerCase().includes(query.toLowerCase()) || data.transaction_type.toLowerCase().includes(query.toLowerCase()) || data.email.toUpperCase().includes(query.toUpperCase())) : this.transactions;
  }


  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  /**
   * Edit transaction - navigates to fleet-motor-add-vehicle component with transaction data
   * Handles loading states appropriately
   */
  editTransaction(transaction: any) {
    if (!transaction || !transaction.policy_sequence) {
      Swal.fire({
        title: 'Error',
        text: 'Unable to load transaction details. Policy sequence is missing.',
        icon: 'error'
      });
      return;
    }

    try {
      // Set quote activity so fleet-motor-add-vehicle knows to load by policy_sequence
      localStorage.setItem('quote_activity', 'edit');
      // Store the full transaction for fallback reference
      localStorage.setItem('motor-quote', JSON.stringify(transaction));
      // Store the policy_sequence so fleet-motor-add-vehicle can fetch the full quote
      localStorage.setItem('edit_policy_sequence', transaction.policy_sequence);
      localStorage.setItem('objecth_position', '0');
      localStorage.setItem('objecth_id', transaction.id ? transaction.id.toString() : '0');

      this.router.navigate(['/fleet-motor-add-vehicle']);

    } catch (error) {
      Swal.fire({
        title: 'Error',
        text: 'Failed to load transaction. Please try again.',
        icon: 'error'
      });
      console.error('Error navigating to edit transaction:', error);
    }
  }

  Transactions(){
    this.router.navigate(['/transactions'])
  }



    Policylists(){
      this.router.navigate(['/policylistings'])
    }


    stickerlistings(){
      this.router.navigate(['/stickerlistings']);
    }

}
